// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3D4Jx","selected":"Chip_selected__2HEua"};